export class TagInput {
    public name: string = '';
}
